<iframe [src]="calendlyUrl! | safe: 'resourceUrl'" [class.loaded]="isCalendlyLoaded"></iframe>

<bp-spinning-logo *ngIf="!isCalendlyLoaded" @fade></bp-spinning-logo>
